export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_21.f2ea956e.jpg";